module.exports = __webpack_public_path__ + "img/step3.9e96964b.svg";